export default __webpack_public_path__ + "static/media/README.79cae190.md";